import { createVueApp } from '../../../create_vue_app'
import { sync } from 'vuex-router-sync'

import DirectMessages from './DirectMessages.vue'
import getStore, { onMessageCreated, onNewMessage } from './store'
import getRouter from './router'
import channel from '../../../socket'

export default async function (el, dataset) {
  const store = getStore({ defaultChatScope: dataset.defaultChatScope })
  const router = getRouter(store)
  const unsync = sync(store, router)

  if (window.location.hash) {
    await router.replace(window.location.hash.replace('#', ''))
  }

  const props = {
    helpCenterURL: dataset.helpCenterUrl,
    discoverPath: dataset.discoverPath,
    defaultChatScope: dataset.defaultChatScope
  }

  channel.on('new_message', onNewMessage(store))
  channel.on('message_created', onMessageCreated(store))

  const app = createVueApp({
    components: { DirectMessages },
    data: function () {
      return { props }
    },
    beforeUnmount: function () {
      channel.off('new_message')
      channel.off('message_created')
      unsync()
    },
    template: '<DirectMessages v-bind="props" />'
  })

  app.use(router)
  app.use(store)
  app.mount(el)

  return () => {
    return app.unmount()
  }
}
